import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import { SpinnerView } from './SpinnerView';
import 'chartjs-adapter-dayjs';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.tz.setDefault('Asia/Tokyo');

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  TimeScale
);

interface CharViewProp {
  title: string;
  data?: { [key: string]: any };
  startTime: dayjs.Dayjs;
  endTime: dayjs.Dayjs;
  limit?: number;
  kind: string;
}

function ChartView(props: CharViewProp) {
  if (props.data === undefined) {
    return <SpinnerView />;
  }

  // 指定時刻から3日分のデータを1時間おきに作成する
  const size = props.endTime.diff(props.startTime, 'hour');
  const labels = [...Array(size).keys()].map((_, key) =>
    props.startTime.add(key, 'hour').format('YYYY/MM/DD HH:mm:ss')
  );

  let option = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'chartArea' as const,
        align: 'center' as const,
        fullSize: true,
        title: {
          display: false,
        },
        labels: {
          boxWidth: 0,
          boxHeight: 0,
          color: 'rgb(255,0,0)',
        },
      },
    },
    scales: {
      x: {
        type: 'time' as const,
        time: {
          parser: 'YYYY/MM/DD HH:mm:ss',
          displayFormats: {
            hour: 'MM/DD HH:00',
          },
          unit: 'hour' as const,
        },
      },
      y: {},
    },
  };

  if (props.kind === 'volt') {
    option.scales.y = {
      type: 'linear' as const,
      stepSize: 500,
      min: 0,
      axis: 'y' as const,
      beginAtZero: true,
    };
  } else if (props.kind === 'battery') {
    option.scales.y = {
      type: 'linear' as const,
      axis: 'y' as const,
      min: -5.0,
      ticks: {
        stepSize: 5,
        precision: 0,
      },
      beginAtZero: true,
    };
  }

  // 指定範囲の中に含むデータを作成
  const graphData = {
    labels: labels,
    datasets: [
      {
        label: props.title,
        data: [
          { x: labels[0], y: props.limit! },
          { x: labels[labels.length - 1], y: props.limit! },
        ],
        borderColor: 'rgb(255,0,0)',
      },
      {
        label: '',
        data: props.data.map((d: any) => {
          return {
            x: d.receive_at,
            y: d[props.kind],
          };
        }),
        borderColor: 'rgba(0,0,240)',
      },
    ],
  };

  return <Line data={graphData} options={option} />;
}

export default ChartView;
